export default __webpack_public_path__ + "static/media/openXMLIcon.ef0f1dcb.svg";